import { Inject, Injectable, Injector } from '@angular/core';

import { LocusRobotics_FlowService } from './LocusRobotics.flow.index';


import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.LocusRobotics = this.injector.get(LocusRobotics_FlowService);
  }

    public LocusRobotics: LocusRobotics_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
